import { useEffect } from 'react';
import type { IssueTransitionModalPayload } from '../../common/types.tsx';
import useTriggerIssueTransitionModal from '../../utils/use-trigger-issue-transition-modal/index.tsx';
import { useTriggerIssueTransitionModalActions } from '../trigger-issue-transition-modal/index.tsx';
import { EVENT_OPEN_ISSUE_TRANSITION_MODAL } from './constants.tsx';
import { ITSPubSub } from './index.tsx';

export const useSubscribeOpenIssueTransitionModalPubSub = () => {
	const [{ isModalOpen }] = useTriggerIssueTransitionModal();
	const { openIssueTransitionModal: openIssueTransitionModalAction } =
		useTriggerIssueTransitionModalActions();

	useEffect(() => {
		const handleMessage = (message: {
			payload?: IssueTransitionModalPayload;
			isEnabled?: boolean;
		}) => {
			if (!isModalOpen) {
				openIssueTransitionModalAction(message.payload, message.isEnabled);
			}
		};

		ITSPubSub.subscribe(EVENT_OPEN_ISSUE_TRANSITION_MODAL, handleMessage);

		return () => {
			ITSPubSub.unsubscribe(EVENT_OPEN_ISSUE_TRANSITION_MODAL, handleMessage);
		};
	}, [isModalOpen, openIssueTransitionModalAction]);

	return null;
};
